import gql from 'graphql-tag'

export const GET_RECRUITMENT = gql`
  query EmployeeRecruitedAts($filter: GetLookupWithFilterInput) {
    employeeRecruitedAts(filter: $filter) {
      isSuccessful
      message
      employeeRecruitedAts {
        data {
          companyId
          srcTable
          srcColumn
          text
          hasRelation
        }
        pagination {
          total
          page
          show
        }
      }
      status
    }
  }
`

export const RECRUITMENT_MUTATION_CREATE = gql`
  mutation CreateEmployeeRecruitedAt($input: CreateLookupInputSimple!) {
    createEmployeeRecruitedAt(input: $input) {
      isSuccessful
      message
      employeeRecruitedAt {
        companyId
        srcTable
        srcColumn
        hasRelation
        text
      }
    }
  }
`

export const RECRUITMENT_MUTATION_DELETE = gql`
  mutation DeleteEmployeeRecruitedAt($input: DeleteLookupInputSimple!) {
    deleteEmployeeRecruitedAt(input: $input) {
      isSuccessful
      message
      employeeRecruitedAt {
        companyId
        srcTable
        srcColumn
        hasRelation
        text
      }
    }
  }
`

export const RECRUITMENT_MUTATION_UPDATE = gql`
  mutation UpdateEmployeeRecruitedAt($input: UpdateLookupInputSimple!) {
    updateEmployeeRecruitedAt(input: $input) {
      isSuccessful
      message
      employeeRecruitedAt {
        companyId
        srcTable
        srcColumn
        hasRelation
        text
      }
    }
  }
`
